import RecentSearches from "./RecentSearches";

export * from "./RecentSearches";

export default RecentSearches;
